module.exports = __webpack_public_path__ + "static/media/passion fruit.d44daa95.png";